<template>
  <div class="edit_channel">
    <div class="header">
      <h4 class="title">
        {{ upd_channel.id? translate('notification.to_edit') : translate('notification.to_add') }}
      </h4>
    </div>
    <div class="block">
        <div class="line row">
          <div class="col-md-12 col-sm-12">
            <fg-input
                v-model="upd_channel.name"
                type="text"
                :label="translate('notification.ch_name')"
                :placeholder="translate('notification.ch_name')"
            />
          </div>
        </div>

        <div class="line row">
          <div class="col-md-12 col-sm-12">
            <div class="form-group">
              <label> {{ translate('notification.ch_type') }} </label>
              <tree-select
                  v-model="upd_channel.type"
                  :options="[{'label':'Telegram', 'id':'telegram'}, {'label':'Email', 'id':'email'}]"
                  :searchable="false"
                  :clearable="false"
                  :show-labels="false"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="true"
              />
            </div>
          </div>
        </div>

        <div class="line row" v-if="upd_channel.type === 'telegram'">
          <div class="col-md-12 col-sm-12">
            <div class="form-group telegram" >
              <label class="telegram__header">
                {{translate('notification.ch_params_telegramm')}}
                <span class="mdi mdi-help" @click="text_assistant = !text_assistant"></span>
                <span class="hide_text" :class="{active: text_assistant}">
                {{translate('notification.text_assistant')}}
                <br>
                <a href='https://t.me/sistematicsbot' target="_blank">@sistematicsbot</a>
              </span>
              </label>

              <input
                  v-model="upd_channel.chat_id"
                  class="form-control border-input error"
                  type="text"
                  @keydown="restrict_chars($event)"
                  :placeholder="translate('notification.ch_params_telegramm')"
              >
            </div>
          </div>
        </div>

      <div class="line row" v-else>
        <div class="col-md-12 col-sm-12" >
          <fg-input
              v-model="upd_channel.email"
              type="text"
              :label="translate('notification.ch_params_email')"
              :placeholder="translate('notification.ch_params_email')"
          />
        </div>
      </div>


      <div class="bottoms">
        <button
          type="submit"
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="updateChannel"
        >
          {{ upd_channel.id? translate('btn.edit') : translate("btn.add") }}
        </button>

        <button
          type="submit"
          class="btn btn-info btn-fill btn-wd"
          @click.prevent="cancel"
        >
          {{ translate('cancel') }}
        </button>

        <button v-if="upd_channel.id !== undefined"
          type="submit"
          class="btn btn-danger btn-fill btn-wd"
          @click.prevent="deleteChannel"
        >
          {{ translate('btn.delete') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EditChannelForm",
  props: ['channel'],
  data () {
    return {
      upd_channel: {
        name: "",
        chat_id: "",
        email: "",
        params: "",
        type: "telegram"
      },
      text_assistant: false
    }
  },
  beforeMount() {
    if (this.channel.isTrusted === true) {
      this.upd_channel.type = 'telegram'
    }else{
      this.upd_channel = {...this.channel}
      if (this.upd_channel.type === 'telegram') {
        this.upd_channel.chat_id = this.upd_channel.params
      }else if (this.upd_channel.type === 'email') {
        this.upd_channel.email = this.upd_channel.params
      }
      this.upd_channel.params = ''
    }
  },
  methods: {
    clear_params(){
      this.upd_channel.params = ''
    },
    cancel () {
      this.$emit('close')
    },
    updateChannel () {
      if (this.upd_channel.type === 'telegram') {
        this.upd_channel.params = this.upd_channel.chat_id
      }else if (this.upd_channel.type === 'email') {
        this.upd_channel.params = this.upd_channel.email
      }

      if (this.upd_channel.name === '' || this.upd_channel.name === undefined) {
        this.global_notify('danger', this.translate('notification.field.name'))
        return
      }

      if (this.upd_channel.type === '' || this.upd_channel.type === undefined) {
        this.global_notify('danger', this.translate('notification.field.type'))
        return
      }

      if (this.upd_channel.params === '' || this.upd_channel.params === undefined) {
        this.global_notify('danger', this.translate('notification.field.params'))
        return
      }

      delete this.upd_channel.email
      delete this.upd_channel.chat_id

      this.$emit('update', this.upd_channel)
      this.$emit('close', this.upd_channel)
    },
    deleteChannel () {
      this.$emit('delete', this.upd_channel)
      this.$emit('close', this.upd_channel)
    }
  },
}

</script>
<style lang='scss' scoped>

  .edit_channel{
    height: 100%;
    padding: 10px;
    .header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
    }
    .block{
      text-align: left;
      .line{
        margin-bottom: 10px;
      }
      .form-group{
        margin-bottom: 0;
      }
      .telegram{
        position: relative;
        &__header{
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
        .mdi-help{
          border-radius: 50%;
          width: 16px;
          height: 16px;
          border: 1px solid #9A9A9A;
          padding: 1px;
          margin-left: 2px;
          -webkit-transition: 0.2s;
          transition: 0.2s;
          cursor: pointer;
          font-size: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover{
            color: #41B883;
            border-color: #41B883;
          }
        }
        .hide_text{
          width: 300px;
          position: absolute;
          bottom: -43px;
          left: 85px;
          z-index: 2;
          white-space: normal;
          background: #f9f9f9;
          padding: 10px;
          border-radius: 5px;
          transition: 0.2s;
          box-shadow: 1px 1px 5px #202020;
          opacity: 0;
          transform: translateY(200px);
          &.active{
            opacity: 1;
            transform: translateY(0);
          }
        }
      }
      .bottoms{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
      }
    }
  }

</style>
